import { Api } from "./api"

export class RedeemCodeApi extends Api {
  constructor() {
    super('voucher_redeemptions', ['code'])
  }
}
